import { ReactTooltipStyled } from "components/atoms/Tooltip/Tooltip.styled";
import { TooltipContainer, TooltipText } from "./PresetTooltip.styled";
export const PresetTooltip = () => {
  return <ReactTooltipStyled id="presetTip" data-sentry-element="ReactTooltipStyled" data-sentry-component="PresetTooltip" data-sentry-source-file="index.tsx">
            <TooltipContainer data-sentry-element="TooltipContainer" data-sentry-source-file="index.tsx">
                <TooltipText data-sentry-element="TooltipText" data-sentry-source-file="index.tsx">
                    Please name your preset. Note that only the fields you fill
                    out will be included in the preset.
                </TooltipText>
            </TooltipContainer>
        </ReactTooltipStyled>;
};